import type { UserDocType } from '@ast-data/shared';

/**
 * Build a `(userId) => display name` resolver (falls back to the raw id for an
 * unknown user). Used to render member-id history diffs with names instead of
 * uuids. Wrap in `useMemo` over (users, userName) at the call site.
 */
export function makeUserResolver(
    users: readonly UserDocType[],
    userName: (user: UserDocType) => string
): (id: string) => string {
    const byId = new Map(users.map((user) => [user.id, user]));
    return (id) => {
        const user = byId.get(id);
        return user ? userName(user) : id;
    };
}
